(function () {
  var launcher = document.getElementById('windy-launcher');
  if (!launcher) return;
  var car = launcher.querySelector('[data-windy-decoration="racing"]');
  var coffee = launcher.querySelector('[data-windy-decoration="coffee"]');
  var racingStart = Date.parse('2026-10-08T00:00:00+08:00');
  var racingEnd = Date.parse('2026-10-12T00:00:00+08:00');
  var coffeeStart = Date.parse('2026-10-27T00:00:00+08:00');
  var coffeeEnd = Date.parse('2027-01-01T00:00:00+08:00');
  var timer;
  function update() {
    var now = Date.now();
    var racing = now >= racingStart && now < racingEnd;
    if (car) car.hidden = !racing;
    if (coffee) coffee.hidden = racing || now < coffeeStart || now >= coffeeEnd;
    window.clearTimeout(timer);
    var next = now < racingStart ? racingStart : now < racingEnd ? racingEnd : now < coffeeStart ? coffeeStart : coffeeEnd;
    if (next > now) timer = window.setTimeout(update, Math.min(next - now + 1, 2147483647));
  }
  update();
  window.addEventListener('pagehide', function () { window.clearTimeout(timer); });
  window.addEventListener('pageshow', update);
})();
